import { MdHistory } from "react-icons/md";
import { Link, useLocation } from "react-router-dom-v5-compat";

import { navAccent } from "../nav/navConstants";
import { docHref, docTypeAccentColor } from "./docNavigation";
import { NavRecentDocRow } from "./NavRecentDocRow";
import { useRecentlyViewedDocs } from "./useRecentlyViewedDocs";

const navRecentLimit = 5;

type Props = {
  onNavigate?: () => void;
};

export const NavRecentDocuments: React.FC<Props> = ({ onNavigate }) => {
  const { data } = useRecentlyViewedDocs(navRecentLimit);
  const location = useLocation();
  const items = data ?? [];

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem", flexShrink: 0 }}>
      <Link
        to="/historia"
        onClick={onNavigate}
        css={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          color: navAccent,
          opacity: 0.6,
          textDecoration: "none",
          "&:hover": { opacity: 1 },
        }}
      >
        <MdHistory css={{ fontSize: "0.875rem" }} />
        <span css={{ fontSize: "0.75rem", fontWeight: 600 }}>Ostatnie dokumenty</span>
      </Link>

      <div css={{ display: "flex", flexDirection: "column", gap: "0.125rem" }}>
        {items.map(({ doc }) => {
          const href = docHref(doc.docType, doc.docId);
          if (!href) return null;

          return (
            <NavRecentDocRow
              key={doc.docId}
              to={href}
              label={doc.name ?? ""}
              accentColor={docTypeAccentColor(doc.docType)}
              isActive={location.pathname.startsWith(href)}
              onClick={onNavigate}
            />
          );
        })}
      </div>
    </div>
  );
};
